import { SHA256 } from "crypto-js";
import {
  InteractionsEventInput,
  MMBEventDto,
  MMBInteractionsEventParamsDto,
  MMBUserPropertiesDto,
  MMBVpvEventParamsDto,
  VpvEventInput,
} from "../dto/event.dto";

export const MMBEvent = (
  data: VpvEventInput | InteractionsEventInput
): MMBEventDto => {
  const dto = new MMBEventDto();
  dto.event = data.type;

  if (data.type === "vpv") {
    const event_params = new MMBVpvEventParamsDto();
    // Copy all base properties
    Object.keys(data).forEach((key) => {
      if (key !== "user_props" && key !== "event" && key !== "type") {
        event_params[key] = data[key];
      }
    });
    dto.event_params = event_params;
  } else {
    const event_params = new MMBInteractionsEventParamsDto();
    // Copy all base properties
    Object.keys(data).forEach((key) => {
      if (key !== "user_props" && key !== "event" && key !== "type") {
        event_params[key] = data[key];
      }
    });
    dto.event_params = event_params;
  }

  if (data.user_props?.pas_dni) {
    const user_properties = new MMBUserPropertiesDto();
    user_properties.pas_dni_hashed = SHA256(data.user_props.pas_dni).toString();
    if (data.user_props.birthday) {
      user_properties.birthday = data.user_props.birthday;
    }
    user_properties.user_type = data.user_props.user_type || "guest";

    dto.user_properties = user_properties;
  }

  return dto;
};

//
// // For VPV events
// const vpvEvent = MMBEvent({
//     type: 'vpv',
//     micrositio: 'mmb',
//     page_path: '/es/chile/mmb/dashboard',
//     page_type: 'Dashboard MMB',
//     page_title: 'Dashboard',
//     homemarket: 'chile',
//     environment: 'production',
//     login: true,
//     negocio: 'retail',
//     // ... other properties
// });
//
// // For Interaction events
// const interactionEvent = MMBEvent({
//     type: 'interacciones',
//     micrositio: 'mmb',
//     page_path: '/es/chile/mmb/dashboard',
//     page_type: 'Dashboard MMB',
//     homemarket: 'chile',
//     environment: 'production',
//     login: true,
//     negocio: 'retail',
//     evento_interactivo_categoria: 'gestiona_tu_viaje',
//     evento_interactivo_accion: 'clic',
//     evento_interactivo_etiqueta: 'modificar_vuelos',
//     // ... other properties
// });